import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClapperboardPlay } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Card, Divider } from '@mui/material'
import { ChangeEvent, FC, useCallback, useState } from 'react'

import { CampaignVideoQuizResults, useCampaignQuizResults } from '@/api/campaigns/campagin-quiz-results'
import { useCampaign } from '@/api/campaigns/get'
import MainTab from '@/common/components/Tabs/MainTab'
import MainTabPage from '@/common/components/Tabs/MainTabPage'
import MainTabs from '@/common/components/Tabs/MainTabs'
import MainTabsWrapper from '@/common/components/Tabs/MainTabsWrapper'
import VideoPreview from '@/common/components/VideoPreview'
import { theme } from '@/theme/theme'
import VideoQuizResults from '../VideoQuizResults'

type CampaignVideoPackagePreviewParams = { campaignId: string }

const CampaignVideoPackagePreview: FC<CampaignVideoPackagePreviewParams> = ({ campaignId }) => {
  const { data: campaignData } = useCampaign(campaignId)
  const [currentTab, setCurrentTab] = useState(0)
  const hasQuizzes = campaignData?.asset_metadata?.include_quiz !== false
  const { data: quizzesResults } = useCampaignQuizResults(campaignId, hasQuizzes)

  const handleTabChange = useCallback(
    (_: ChangeEvent<{}>, index: number) => {
      setCurrentTab(index)
    },
    [setCurrentTab]
  )

  return (
    <>
      <MainTabsWrapper>
        <MainTabs value={currentTab} onChange={handleTabChange} variant="scrollable" scrollButtons={'auto'}>
          {campaignData?.assets.map((video: any, index: number) => (
            <MainTab
              key={index}
              label={video.title}
              icon={<FontAwesomeIcon icon={faClapperboardPlay as IconProp} fontSize={18} />}
              iconPosition="start"
            />
          ))}
        </MainTabs>
      </MainTabsWrapper>
      {campaignData?.assets.map((video: any, index: number) => {
        return (
          <MainTabPage key={video.id} hidden={currentTab !== index}>
            <Card sx={{ minWidth: '500px' }}>
              <VideoPreview video={video} />
            </Card>
            <Box>
              <Divider sx={{ margin: theme.spacing(0, 4) }} />
              <VideoQuizResults
                videoId={video._id}
                hasQuizzes={hasQuizzes}
                quizResults={quizzesResults?.[video.id] as CampaignVideoQuizResults}
              />
            </Box>
          </MainTabPage>
        )
      })}
    </>
  )
}

export default CampaignVideoPackagePreview
